import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  Headline,
  HeadlineRightPanel,
  TextButton,
} from '@banhala/ui-kit';
import { useCallback } from 'react';
import { isWeb } from 'shared/src/utils';
import { MumulLiveContentsGrid } from '../components/MumulLiveContentsGrid';
import { useLogMumulLiveContents } from './useLogMumulLiveContents';

type UseShowMumulLiveContentsBottomSheetParam = {
  marketName: string;
  profileSno: number;
  onPressProfile: () => void;
  onPressPost: (postSno: number) => void;
};

export const useShowMumulLiveContentsBottomSheet = createUseBottomSheetModal<
  void,
  UseShowMumulLiveContentsBottomSheetParam
>(
  ({
    param: { marketName, profileSno, onPressProfile, onPressPost },
    cancel,
  }) => {
    const { logClickMumulLiveProfile } = useLogMumulLiveContents(profileSno);

    // 웹은 같은 창에서 라우팅되므로 바텀시트가 위에 남는다. 먼저 닫고 랜딩한다.
    const handlePressProfile = useCallback(() => {
      logClickMumulLiveProfile();
      if (isWeb) cancel();
      onPressProfile();
    }, [logClickMumulLiveProfile, cancel, onPressProfile]);

    const handlePressPost = useCallback(
      (postSno: number) => {
        if (isWeb) cancel();
        onPressPost(postSno);
      },
      [cancel, onPressPost],
    );

    return (
      <BottomSheetContainer showHandleBar={true} maxHeight={'60%'}>
        <Headline
          size={'medium'}
          headline={`${marketName} 콘텐츠 모아보기`}
          rightPanel={
            <HeadlineRightPanel type={'textButton'}>
              <TextButton
                color={'blue'}
                size={'small'}
                onPress={handlePressProfile}
              >
                프로필 보기
              </TextButton>
            </HeadlineRightPanel>
          }
        />
        <MumulLiveContentsGrid
          profileSno={profileSno}
          onPressPost={handlePressPost}
        />
      </BottomSheetContainer>
    );
  },
);
